import { ListItemButton, ListItemText, Paper, Typography, useTheme } from '@mui/material';
import { PolicyRule } from '../../model/interfaces/policyRule';

interface ClickableRuleProps {
  rule: PolicyRule;
  onSelectRule: (rule: PolicyRule) => void;
  selected: boolean;
}

const RuleListItem = (props: ClickableRuleProps) => {
  const usePalette = useTheme().palette
  const { rule, onSelectRule, selected } = props;
  return (
    <ListItemButton
      selected={selected}
      onClick={() => onSelectRule(rule)}
      component={Paper}
      sx={{ backgroundColor:usePalette.secondary.main, paddingY: 0.5, borderRadius: 0.5 }}>
      <ListItemText
        secondaryTypographyProps={{
          sx: { overflow: 'hidden', textOverflow: 'ellipsis' },
          noWrap: true
        }}
        primaryTypographyProps={{
          sx: { overflow: 'hidden', textOverflow: 'ellipsis' },
          noWrap: true
        }}
        primary={<Typography variant={'body2'}>{rule.name}</Typography>}
        secondary={<Typography variant={'caption'}>{rule.description}</Typography>}
      />
    </ListItemButton>
  );
};

export default RuleListItem;
